import { IApiSuccessWrapper, IExportStatus } from '$/types'
import { apiSlice } from 'app/services/api'
import { IPhmsaExportParams } from 'features/RegulatoryTools/PHMSA/types'

export const phmsaReportApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    addPhmsaReportExportJob: build.mutation<IExportStatus, IPhmsaExportParams>({
      query: ({ exportDate, operatorList }) => ({
        method: 'POST',
        url: '/phmsa/export',
        body: {
          exportDate,
          operatorList
        }
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IExportStatus
      }
    })
  })
})

export const { useAddPhmsaReportExportJobMutation } = phmsaReportApi
